import request from '../axios'

export const apiLogin = user =>
  request.post(
    '/manage/oauth/administrator/account/login',
    user
  )
